import { EventOptions } from '..'
import { Action } from '../actions'
import UnhandledError from '../UnhandledError'
import { BroadcastChild, broadcastToChild } from './child'
import { broadcastToParent } from './parent'

export type EventPayload<
  E extends string = string,
  T = any
> = E extends 'action' ? Action<E, T> : T

export interface Broadcast<E extends string, T = any> {
  eventName: E
  options?: EventOptions
  data?: EventPayload<E, T> | null
  error?: UnhandledError
}

export type BroadcastTarget = 'child' | 'parent'

export function broadcast<
  E extends string,
  T = any,
  BT extends BroadcastTarget = BroadcastTarget
>(
  target: BT,
  config: BT extends 'child' ? BroadcastChild<E, T> : Broadcast<E, T>
) {
  if (target === 'child') {
    broadcastToChild<E, T>(config)
    return
  }

  broadcastToParent<E, T>(config)
}
